import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { DepartmentsComponent } from './pages/departments/departments.component';
import { PrioritiesComponent } from './pages/priorities/priorities.component';
import { StuckProjectsComponent } from './pages/stuck-projects/stuck-projects.component';
import { DelayedProjectsComponent } from './pages/delayed-projects/delayed-projects.component';
import { ProjectDetailComponent } from './pages/project-detail/project-detail.component';
import { LoginComponent } from './pages/login/login.component';
import { InterventionProjectsComponent } from './pages/intervention-projects/intervention-projects.component';
import { HomeComponent } from './pages/home/home.component';
import { FieldExecutionComponent } from './pages/field-execution/field-execution.component';
import { VillageListComponent } from './pages/field-execution/village-list/village-list.component';
import { ExecutantDetailComponent } from './pages/field-execution/executant-detail/executant-detail.component';
import { authGuard } from './guards/auth.guard';

import { UserManagementComponent } from './pages/admin/user-management/user-management.component';
import { DepartmentManagementComponent } from './pages/admin/department-management/department-management.component';
import { ApprovalManagementComponent } from './pages/admin/approval-management/approval-management.component';
import { SchemeManagementComponent } from './pages/admin/scheme-management/scheme-management.component';
import { OperatorDashboardComponent } from './pages/operator/operator-dashboard.component';
import { ApproverDashboardComponent } from './pages/approver/approver-dashboard.component';
import { roleGuard } from './guards/role.guard';

export const routes: Routes = [
    { path: 'login', component: LoginComponent },
    {
        path: '',
        canActivate: [authGuard],
        children: [
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            { path: 'home', component: HomeComponent },
            { path: 'field-execution', component: FieldExecutionComponent },
            { path: 'field-execution/executant/:key', component: ExecutantDetailComponent },
            { path: 'field-execution/:block', component: VillageListComponent },
            {
                path: 'dhamnagar-dashboard',
                component: MainLayoutComponent,
                children: [
                    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
                    { path: 'dashboard', component: DashboardComponent },
                    { path: 'departments', component: DepartmentsComponent },
                    { path: 'priorities', component: PrioritiesComponent },
                    { path: 'stuck', component: StuckProjectsComponent },
                    { path: 'delayed-projects', component: DelayedProjectsComponent },
                    { path: 'intervention', component: InterventionProjectsComponent },
                    { path: 'project/:id', component: ProjectDetailComponent },
                    
                    // Operator & Approver Modules
                    { 
                        path: 'operator', 
                        component: OperatorDashboardComponent,
                        canActivate: [roleGuard],
                        data: { allowedRoles: ['operator', 'admin'] }
                    },
                    { 
                        path: 'approver', 
                        component: ApproverDashboardComponent,
                        canActivate: [roleGuard],
                        data: { allowedRoles: ['approver', 'admin'] }
                    },

                    // Admin Modules
                    { 
                        path: 'user-management', 
                        component: UserManagementComponent,
                        canActivate: [roleGuard],
                        data: { allowedRoles: ['admin'] }
                    },
                    { 
                        path: 'department-master', 
                        component: DepartmentManagementComponent,
                        canActivate: [roleGuard],
                        data: { allowedRoles: ['admin'] }
                    },
                    { 
                        path: 'approval-requests', 
                        component: ApprovalManagementComponent,
                        canActivate: [roleGuard],
                        data: { allowedRoles: ['admin', 'osd', 'minister'] }
                    },
                    { 
                        path: 'scheme-management', 
                        component: SchemeManagementComponent,
                        canActivate: [roleGuard],
                        data: { allowedRoles: ['admin', 'osd', 'minister'] }
                    }
                ]
            }
        ]
    },
    { path: '**', redirectTo: '/login' }
];
